export default "__VITE_ASSET__DKTTVtgG__"